"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatNumber(num) {
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
exports.default = formatNumber;
